<div>
    <div>
        <label for="name">{{data.heading}}</label>
        <input type="text" [(ngModel)]="name" class="form-control">
    </div>
    <div class="pop-btn-div">
        <button (click)="close()" class="btn btn-outline-secondary">Close</button>
        <button (click)="addNew()" class="btn btn-outline-success">Add New</button>
    </div>
</div>